/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "maijznderppqdvvtdfdj"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1haWp6bmRlcnBwcWR2dnRkZmRqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzEzMDE5MDUsImV4cCI6MjA4Njg3NzkwNX0.SJp2yL9UHaxiiaT4Q9odbewRk6BWF5Y1ty2cHL-PTNg"